import styled from 'styled-components';

import { color } from '../../../../atoms/colors';
import { font } from '../../../../atoms/typography';
import { spacing } from '../../../../atoms/spacing';

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  ${props => props.hidden && `display: none;`}

  &.hidden {
    display: none;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[6]};
`;

export const Label = styled.label`
  ${font('text', 'sm', '400')}
  color: ${color.darkBlue[700]};
`;

export const Input = styled.input`
  width: 100%;
  padding: ${spacing[10]} ${spacing[14]};
  border-radius: ${spacing[8]};
  border: 1px solid ${color.darkBlue[100]};
  background: ${color.common.white};
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  ${font('text', 'sm', '400')}
  color: ${color.darkBlue[600]};

  &::placeholder {
    ${font('text', 'sm', '400')}
    color: ${color.darkBlue[600]};
  }

  &:focus {
    box-shadow: none;
    outline: 3px solid ${color.blue[700]};
  }

  &.error {
    border: 1px solid ${color.primary[1000]};
  }
`;

export const ErrorMessage = styled.div`
  &,
  & p,
  & a {
    ${font('text', 'xs', '700')}
    color: ${color.primary[1000]};
  }
  margin-top: 4px;
`;
